import { ExpiredCouponCard } from '@pelando/components';
import { StoreDeal } from '@/domain/entities/Store';
import { AlgoliaEvents, EventCategory } from '@/domain/events/analytics';
import { emitTrackingEvent } from '@/infra/analytics/emitTrackingEvent';
import { STORE_MERCADO_LIVRE } from '@/presentation/modules/StoreTabs';
import useDealUrl from '../../hooks/dealUrl';
import getStampType from '../../services/deals/getStampType';
import { ClickoutComponentSource } from '../../services/urls';
import { useTranslation } from '../../hooks/useTranslation';

type StoreExpiredCouponCardProps = {
  expiredCoupon: StoreDeal;
  redirectToStore: (url: string) => void;
  currentUserId?: string;
};

const StoreExpiredCouponCard = ({
  expiredCoupon,
  redirectToStore,
  currentUserId,
}: StoreExpiredCouponCardProps) => {
  const isMercadoLivre = expiredCoupon.store?.slug === STORE_MERCADO_LIVRE;

  const { url, goToClickoutUrl, clickoutUrl } = useDealUrl({
    deal: expiredCoupon,
    storeUrl: expiredCoupon.store?.url,
    bodyCoupon: expiredCoupon.couponCode,
    couponHash: `#coupon=${expiredCoupon.id}`,
    componentSource: ClickoutComponentSource.StorePageGetDiscount,
    showCouponOnDealPage: true,
    currentUserId,
  });

  const { t } = useTranslation('coupons');

  const handleActivateButtonClick = () => {
    emitTrackingEvent({
      category: EventCategory.Algolia,
      name: AlgoliaEvents.ClickOut,
      extra: {
        deal_id: expiredCoupon.id,
      },
    });
    redirectToStore(clickoutUrl as unknown as string);
  };

  const handleCodeButtonClick = () => {
    emitTrackingEvent({
      category: EventCategory.Algolia,
      name: AlgoliaEvents.ClickOut,
      extra: {},
    });

    if (isMercadoLivre) {
      setTimeout(() => {
        window.location.href = url;
        window.location.reload();
      }, 100);
    } else if (goToClickoutUrl) {
      setTimeout(() => {
        window.open(url, '_blank');
      }, 100);
      goToClickoutUrl();
    }
  };

  return (
    <ExpiredCouponCard
      key={expiredCoupon.id}
      id={expiredCoupon.id}
      onActivateButtonClick={handleActivateButtonClick}
      onCouponCodeClick={handleCodeButtonClick}
      stampType={getStampType({
        discountFixed: expiredCoupon.discountFixed,
        discountPercentage: expiredCoupon.discountPercentage,
        freeShipping: expiredCoupon.freeShipping,
        price: expiredCoupon.price,
      })}
      title={expiredCoupon.title}
      code={expiredCoupon.couponCode || undefined}
      value={
        expiredCoupon.discountFixed ||
        expiredCoupon.discountPercentage ||
        expiredCoupon.price ||
        0
      }
      seeDealButtonLabel={t('see-deal-button-label')}
    />
  );
};

export default StoreExpiredCouponCard;
